<template>
  <div v-if="internalValue">
    <draggable v-model="internalValue" @start="drag=true" @end="drag=false" :options="{handle:'.drag'}">
    <div v-for="(attribute, i) in internalValue" class="option-attribute">
      <div>
        <div class="drag"><strong>{{ labels['90'] }} {{ labels[attribute.id] }}</strong> ({{ attribute.id }})</div>
        <div></div>
        <div><label><input type="checkbox" v-model="attribute.multiple"/> Multiple</label></div>
        <div><label><input type="checkbox" v-model="attribute.required"/> Mandatory</label></div>
        <div><button @click="removeNode(internalValue, i)"><i class="icon icon-icon_close"></i></button></div>
      </div>
      <div class="option-attribute-values">
        <draggable v-model="attribute.values" @start="drag=true" @end="drag=false" :options="{handle:'.drag'}">
          <div v-for="(value, index) in attribute.values" v-show="attribute.values" class="option-attribute-value">
            <div>
              <div class="drag"><strong>{{ labels[attribute.id + '.' + value.id] }}</strong> ({{ value.id }})</div>
              <div>
                <input type="text" v-model="value.price" placeholder="+0"/>
              </div>
              <div><i class="icon icon-icon_tick" v-if="attribute.default_value == attribute.id + '.' + value.id"></i></div>
              <div><button @click="asDefault(internalValue, i, attribute.id + '.' + value.id)"><span>As default</span></button></div>
              <div><select @change="addAttribute($event, value)">
                <option value="" selected>Ajouter un attribut</option>
                <option v-for="attr in attributes" :value="attr.id">{{ attr.name }}</option>
              </select></div>
              <div><button @click="removeNode(attribute.values, index)"><i class="icon icon-icon_close"></i></button></div>
            </div>
            <div class="option-attributes">
              <draggable-option v-model="value.children" :key="value.id" :labels="labels" :attributes="attributes"></draggable-option>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    </draggable>
  </div>
</template>
<script>

import draggableOption from './Option.vue';

export default {
  name: 'draggableOption',
  components:{
    'draggableOption': draggableOption
  },
  props: ['value', 'labels', 'attributes'],
  data () {
    return {
      internalValue: null,
      drag: false,
      calculation: [
        {name: 'addition', id: '+'},
        {name: 'soustraction', id: '-'},
        {name: 'multiplication', id: '*'}
      ]
    }
  },
  mounted: function(){
    this.internalValue = this.value;
    console.log("alert !!!!!!!!", this.value)
  },
  methods:{
    addAttribute: function(e, node)
    {

      let attributeId = e.target.value;
      let attribute = null;

      let exists = node.children.filter(function (o) {
        return o.id == attributeId;
      }).length > 0;

      if( exists ){
        alert("Cet attribut existe figure déjà dans votre élément !")
        return false;
      }

      for(let item of this.attributes){
        if( item.id == attributeId ){
          attribute = item;
        }
      }

      console.log("addAttribute", attribute, node)

      let values = [];
      for(let value of attribute.values){
        if( attribute.parent_id == null ){
          values.push({
            id: value.id,
            slug: attribute.id + '.' + value.slug,
            label: value.name,
            price: '+0',
            children: []
          });
        }
      }

      node.children.push({
        id: attribute.id,
        slug: attribute.id,
        label: attribute.name,
        required: false,
        values: values
      });

      e.target.value = '';


    },
    asDefault: function(attribute, index, value)
    {
      attribute[index].default_value = value;
      this.$forceUpdate()
    },
    removeNode: function(array, index)
    {
      array.splice(index, 1);
    }
  },
  watch: {
    'value'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.internalValue = newVal;
      }
    },
    'internalValue'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$emit('input', this.internalValue);
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/modules/shop/option/Option.vue